module.exports = __webpack_public_path__ + "img/sing.932ed672.jpg";